


import { Injectable, Inject } from '@angular/core';
import{BaseDO} from './base.model';


export class GroupPolicyDetailDO extends BaseDO  {
    
     public  id:number = null;
     public proposalNum:string;
     public reconcileStatusCd:string;
     public productCd:string;
     public productVersion:string;
     public statusCd:string;
     public stageCd:string;
     public uwDecisionCd:string;
     public coResponseCd:string;
     public sumInsured:number;
     public finalPremium:number;

}